const stats = [
  { value: '70%', label: 'экономия времени на создание контента с AI-SEO', icon: 'ri-time-line' },
  { value: '3×', label: 'рост органического трафика за 6 месяцев сопровождения', icon: 'ri-line-chart-line' },
  { value: '0 ₽', label: 'дополнительного рекламного бюджета для роста охвата', icon: 'ri-money-dollar-box-line' },
];

export default function SupportBenefits() {
  return (
    <section className="py-14 sm:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 sm:mb-6">
            Почему это выгодно?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-4 sm:mb-6 rounded-full"></div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-10 sm:mb-16">
          {/* Left: Image */}
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden w-full aspect-video">
            <img
              src="https://public.readdy.ai/ai/img_res/0af3b3413e0dda349a5787adf66e0639.jpg"
              alt="AI-SEO технологии"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B4C]/60 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6">
              <div className="bg-white/95 backdrop-blur-sm rounded-xl sm:rounded-2xl px-4 py-3 sm:px-6 sm:py-4">
                <p className="text-[#1A2B4C] font-bold text-xs sm:text-sm font-['Montserrat']">
                  <i className="ri-robot-2-line text-[#C5A880] mr-2"></i>
                  AI-SEO — интеллект на службе вашего роста
                </p>
              </div>
            </div>
          </div>

          {/* Right: Text */}
          <div>
            <div className="bg-[#C5A880]/10 border-l-4 border-[#C5A880] rounded-r-xl sm:rounded-r-2xl p-4 sm:p-6 mb-4 sm:mb-6">
              <p className="text-[#1A2B4C] font-bold text-sm font-['Montserrat'] mb-2">
                С помощью AI-SEO (Искусственный Интеллект и Поисковая Выдача)
              </p>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify">
                Мы готовим контент, который экономит до <strong className="text-[#1A2B4C]">70% времени</strong> на производство, но при этом проходит жёсткий контроль качества. Мы «очеловечиваем» каждый текст, чтобы он был полезен людям и не попал под фильтры поисковиков.
              </p>
            </div>

            <div className="bg-[#1A2B4C] rounded-xl sm:rounded-2xl p-4 sm:p-6">
              <h4 className="text-[#C5A880] font-bold text-sm font-['Montserrat'] mb-2 uppercase tracking-wider">
                Результат:
              </h4>
              <p className="text-white text-sm sm:text-lg leading-relaxed font-['Montserrat'] text-justify">
                Ваш сайт не просто «висит в интернете», а <strong className="text-[#C5A880]">постоянно растёт в охватах</strong>, привлекая всё больше целевых клиентов без увеличения рекламного бюджета.
              </p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="text-center bg-gradient-to-b from-gray-50 to-white border border-gray-100 rounded-2xl p-5 sm:p-8"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl sm:text-3xl text-[#C5A880]`}></i>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
                {stat.value}
              </div>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-center">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
